import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBarModal from '../general/AppBarModal';
import { TableRow, TableCell, TableBody, Table, Dialog, DialogContent, DialogActions, Grid, IconButton } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import moment from 'moment';
import TareasTerminadas from '../general/TareasTerminadas';
import emma_w from '../../global/imagenes/emma_w.png';
import { consulta } from '../../global/js/funciones';
import ListarDatos from '../general/ListarDatos';
import { BtnForm } from '../general/BotonesAccion';
import { AcompanamientoMenu } from './MenuAcompanamiento';
import {RESPUESTA_OTROS} from './helper';

class DetalleAcompanamientoDocente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: false,
      seleccion: 'detalle',
      docente_solicitante_nombre: '',
      docente_solicitante_identificacion: '',
      programa: '',
      asignatura: '',
      nombre_grupo_asignatura: '',
      periodo: '',
      fecha_registro: '',
      estado_actual: '',
      estados: [],
      estudiantes: [],
      modalRespuestas: false,
      estudianteSeleccionado: null
    };
  }

  componentDidUpdate({ modalDetalleAcompanamiento, mostrarModalDetalleAcompanamiento }, { seleccion }) {
    let { modalDetalleAcompanamiento: modalDetalleAcompanamientoNew, mostrarModalDetalleAcompanamiento: mostrarModalDetalleAcompanamientoNew, cargar } = this.props;
    
    // Solo cargar datos cuando el modal se abre por primera vez
    if (modalDetalleAcompanamiento !== modalDetalleAcompanamientoNew && modalDetalleAcompanamientoNew && cargar) {
      this.setState({ cargando: true, cargar: false });
      this.obtenerDatos();
      this.obtenerEstados();
    }
    
    // Manejar cambios de selección dentro del modal
    let { seleccion: seleccionNew } = this.state;
    if (seleccion !== seleccionNew && modalDetalleAcompanamientoNew && mostrarModalDetalleAcompanamientoNew) {
      if (seleccionNew === 'detalle') this.obtenerDatos();
      else if (seleccionNew === 'estado') this.obtenerEstados();
      else if (seleccionNew === 'estudiantes') this.obtenerEstudiantes();
    }
  }

  async obtenerEstados() {
    let { proceso } = this.props;
    let f = proceso.id;
    this.setState({ cargando: true });
    consulta(`api/v1.0/acompanamiento_docente/estados/detalle/${f}?`, null, null, (error, estado, resp) => {
      if (estado === 200) this.setState({ cargando: false, estados: resp });
    });
  }

  async obtenerEstudiantes() {
    let datos = await this.obtenerSolicitud();
    let estudiantes = datos && datos[0] && datos[0].estudiantes ? datos[0].estudiantes : [];
    this.setState({ 
      cargando: false, 
      estudiantes: estudiantes
    });
  }

  async obtenerDatos() {
    let datos = await this.obtenerSolicitud();
    this.setState({
      docente_solicitante_nombre: `${datos[0].docente_solicitante.primer_nombre} ${datos[0].docente_solicitante.primer_apellido} ${datos[0].docente_solicitante.segundo_apellido || ''}`,
      docente_solicitante_identificacion: datos[0].docente_solicitante.identificacion,
      programa: datos[0].programa ? datos[0].programa.nombre : '',
      asignatura: datos[0].asignatura,
      nombre_grupo_asignatura: datos[0].nombre_grupo_asignatura,
      periodo: datos[0].periodo,
      fecha_registro: datos[0].fecha_registro,
      estado_actual: datos[0].estado_actual ? datos[0].estado_actual.nombre : '',
      cargando: false,
      cargar: false
    });
  }

  async obtenerSolicitud() {
    let { proceso } = this.props;
    let f = proceso.id;
    this.setState({ cargando: true });
    return new Promise(resolve => {
      consulta(`api/v1.0/acompanamiento_docente/detalle/${f}?`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      });
    });
  }

  pintarDetalle = () => {
    let {
      docente_solicitante_nombre,
      docente_solicitante_identificacion,
      programa,
      asignatura,
      nombre_grupo_asignatura,
      periodo,
      fecha_registro,
      estado_actual
    } = this.state;

    let fecha_registro_format = moment(fecha_registro).format('YYYY-MM-DD, h:mm a');
    
    return (
      <Table>
        <TableBody>
          <TableRow key={1}>
            <TableCell component="th" scope="row">Docente Solicitante</TableCell>
            <TableCell align="left">{docente_solicitante_nombre}</TableCell>
          </TableRow>
          <TableRow key={2}>
            <TableCell component="th" scope="row">Identificación</TableCell>
            <TableCell align="left">{docente_solicitante_identificacion}</TableCell>
          </TableRow>
          <TableRow key={3}>
            <TableCell component="th" scope="row">Programa</TableCell>
            <TableCell align="left">{programa}</TableCell>
          </TableRow>
          <TableRow key={4}>
            <TableCell component="th" scope="row">Asignatura</TableCell>
            <TableCell align="left">{asignatura}</TableCell>
          </TableRow>
          <TableRow key={5}>
            <TableCell component="th" scope="row">Grupo</TableCell>
            <TableCell align="left">{nombre_grupo_asignatura}</TableCell>
          </TableRow>
          <TableRow key={6}>
            <TableCell component="th" scope="row">Periodo</TableCell>
            <TableCell align="left">{periodo}</TableCell>
          </TableRow>
          <TableRow key={7}>
            <TableCell component="th" scope="row">Estado Actual</TableCell>
            <TableCell align="left">{estado_actual}</TableCell>
          </TableRow>
          <TableRow key={8}>
            <TableCell component="th" scope="row">Fecha Registro</TableCell>
            <TableCell align="left">{fecha_registro_format}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  pintarDetalleEstado = () => {
    let { estados } = this.state;
    const obtenerColor = (estado) => {
      let color = 'white';
      const colores = {
        'acom_docen_Regis': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
        'acom_docen_Pendie': { 'backgroundColor': '#967300ff', color },
        'acom_docen_Finali': { 'backgroundColor': '#009688', color },
        'Tod_Acomp': { 'backgroundColor': '#0d47a1', color }
      };
      return (colores[estado] || { 'backgroundColor': '#f5f5f5', 'color': '#757575' });
    };

    return (
      <ListarDatos
        datos={estados}
        titulo=''
        id='tbl_estados_acompanamiento'
        avatar={({ tipo_estado }) => tipo_estado.nombre.toUpperCase().charAt(0)}
        color_avatar={({ tipo_estado }) => obtenerColor(tipo_estado.codigo)}
        fila_principal={({ tipo_estado }) => tipo_estado.nombre}
        filas={[
          { 'id': 'fecha', 'mostrar': ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a'), 'nombre': 'Fecha: ' },
          { 'id': 'usuario', 'mostrar': ({ usuario_registro: { primer_nombre, primer_apellido, segundo_apellido } }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido || ''}` },
          { 'id': 'mensaje', 'mostrar': ({ mensaje }) => mensaje },
          { 'id': 'observacion', 'mostrar': ({ observaciones }) => observaciones, 'ocultar': ({ observaciones }) => !observaciones }
        ]}
      />
    );
  }

  abrirModalRespuestas = (estudiante) => {
    this.setState({ modalRespuestas: true, estudianteSeleccionado: estudiante });
  }

  cerrarModalRespuestas = () => {
    this.setState({ modalRespuestas: false, estudianteSeleccionado: null });
  }

  pintarModalRespuestas = () => {
    let { estudianteSeleccionado } = this.state;
    if (!estudianteSeleccionado) return null;

    return (
      <Table>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">Estudiante</TableCell>
            <TableCell>{`${estudianteSeleccionado.estudiante_acompanamiento.primer_nombre} ${estudianteSeleccionado.estudiante_acompanamiento.primer_apellido}`}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">Cédula</TableCell>
            <TableCell>{estudianteSeleccionado.cedula_estudiante_acompanamiento}</TableCell>
          </TableRow>
          {estudianteSeleccionado.observacion_inicial && (
            <TableRow style={{ backgroundColor: '#fff3cd' }}>
              <TableCell component="th" scope="row" style={{ fontWeight: 'bold', color: '#856404' }}>Observación del Reporte</TableCell>
              <TableCell style={{ color: '#856404' }}>{estudianteSeleccionado.observacion_inicial}</TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell component="th" scope="row">Descripción General</TableCell>
            <TableCell>{estudianteSeleccionado.descripcion_general}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">Seguimiento Realizado</TableCell>
            <TableCell>{estudianteSeleccionado.seguimiento_realizado}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">Verificación Grupo Priorizado</TableCell>
            <TableCell>{estudianteSeleccionado.verificación_grupo_priorizado?.nombre}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">Clasificación Tipo de Caso</TableCell>
            <TableCell>
              {estudianteSeleccionado.clasificacion_tipo_de_caso?.map((caso, index) => (
                <div key={index}>{caso.nombre}</div>
              ))}
            </TableCell>
          </TableRow>
          {estudianteSeleccionado.observaciones && (
            <TableRow>
              <TableCell component="th" scope="row">Observaciones</TableCell>
              <TableCell>{estudianteSeleccionado.observaciones}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    );
  }

  pintarDetalleEstudiantes = () => {
    let { estudiantes } = this.state;
    
    if (!estudiantes || estudiantes.length === 0) {
      return <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>No hay estudiantes para mostrar</div>;
    }
    
    return (
      <Table>
        <TableBody>
          {estudiantes.map((estudiante, index) => (
            <TableRow 
              key={index} 
              style={{ 
                backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff'
              }}
            >
              <TableCell style={{ padding: '16px', borderLeft: '4px solid #b70e0c' }}>
                <div style={{ 
                  color: '#b70e0c', 
                  fontWeight: 'bold', 
                  fontSize: '16px',
                  marginBottom: '8px'
                }}>
                  {estudiante.estudiante_acompanamiento ? 
                    `${estudiante.estudiante_acompanamiento.primer_nombre} ${estudiante.estudiante_acompanamiento.primer_apellido}` : 
                    'Estudiante'
                  }
                </div>
                <div style={{ color: '#666', fontSize: '14px', marginBottom: '4px' }}>
                  <strong>Cédula:</strong> <span style={{ color: '#333' }}>{estudiante.cedula_estudiante_acompanamiento || 'N/A'}</span>
                </div>
                <div style={{ color: '#666', fontSize: '14px', marginBottom: '4px' }}>
                  <strong>Correo:</strong> <span style={{ color: '#333' }}>{estudiante.estudiante_acompanamiento?.correo || 'N/A'}</span>
                </div>
                {estudiante.observacion_inicial && (
                  <div style={{ 
                    backgroundColor: '#fff3cd', 
                    padding: '8px', 
                    borderRadius: '4px', 
                    marginTop: '8px',
                    border: '1px solid #ffeaa7'
                  }}>
                    <div style={{ color: '#856404', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>
                      Observación del Reporte:
                    </div>
                    <div style={{ color: '#856404', fontSize: '13px', fontStyle: 'italic' }}>
                      {estudiante.observacion_inicial}
                    </div>
                  </div>
                )}
              </TableCell>
              <TableCell style={{ textAlign: 'center', width: '80px', verticalAlign: 'top', paddingTop: '20px' }}>
                <IconButton 
                  onClick={() => this.abrirModalRespuestas(estudiante)}
                  title="Ver respuestas"
                  style={{ 
                    backgroundColor: '#b70e0c',
                    color: 'white',
                    '&:hover': { backgroundColor: '#b70e0c' }
                  }}
                >
                  <VisibilityIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  pintar = () => {
    let { cargando, seleccion } = this.state;
    if (cargando) return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />;
    return (
      <>
        {seleccion === 'detalle' && this.pintarDetalle()}
        {seleccion === 'estado' && this.pintarDetalleEstado()}
        {seleccion === 'estudiantes' && this.pintarDetalleEstudiantes()}
      </>
    );
  }

  limpiarEstado = () => {
    this.setState({
      seleccion: 'detalle',
      cargando: false,
      estados: [],
      estudiantes: [],
      modalRespuestas: false,
      estudianteSeleccionado: null,
      docente_solicitante_nombre: '',
      docente_solicitante_identificacion: '',
      programa: '',
      asignatura: '',
      nombre_grupo_asignatura: '',
      periodo: '',
      fecha_registro: '',
      estado_actual: ''
    });
  }

  cerrarModal = () => {
    let { cerrarModal } = this.props;
    this.limpiarEstado();
    if (cerrarModal) cerrarModal();
  }

  render() {
    let { modalDetalleAcompanamiento, mostrarModalDetalleAcompanamiento } = this.props;
    let { seleccion, modalRespuestas } = this.state;

    return (
      <>
        <Dialog fullWidth={true} maxWidth="sm" open={modalDetalleAcompanamiento && mostrarModalDetalleAcompanamiento} onClose={this.cerrarModal}>
          <AppBarModal titulo={" ¡ Detalle Acompañamiento Docente ! "} mostrarModal={this.cerrarModal} titulo_accion="Cerrar" accion={this.cerrarModal} />
          <AcompanamientoMenu sele={seleccion} seleccionar={seleccion => this.setState({ seleccion })} />
          <DialogContent className='scroll'>
            <Grid container>
              <Grid item xs={12} md={12}>
                {this.pintar()}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Cerrar" callback={this.cerrarModal} />
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={true} maxWidth="sm" open={modalRespuestas} onClose={this.cerrarModalRespuestas}>
          <AppBarModal titulo={" ¡ Respuestas del Estudiante ! "} mostrarModal={this.cerrarModalRespuestas} titulo_accion="Cerrar" accion={this.cerrarModalRespuestas} />
          <DialogContent className='scroll'>
            <Grid container>
              <Grid item xs={12} md={12}>
                {this.pintarModalRespuestas()}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Cerrar" callback={this.cerrarModalRespuestas} />
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default DetalleAcompanamientoDocente;